import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

interface CustomTooltipProps extends TooltipProps {
  bgColor?: string
  maxWidth?: string
}

const CustomColorTooltip = styled(({ className, bgColor, maxWidth, ...rest }: CustomTooltipProps) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <Tooltip {...rest} classes={{ popper: className }} />
))(({ bgColor, maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${bgColor}`,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
    padding: '10px',
    ...(maxWidth ? { maxWidth } : {}),
  },
  '& .MuiTooltip-arrow': {
    color: `${bgColor}`,
  },
}))
export default CustomColorTooltip
